import { Component, Input, OnChanges } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "app-event-image",
    imports: [],
    templateUrl: "./event-image.component.html",
    styleUrl: "./event-image.component.scss"
})
export class EventImageComponent implements OnChanges {
  @Input() thumbnail: string | null = null;
  @Input() isEventFinished = false;

  eventImage!: SafeUrl | undefined;

  ngOnChanges(): void {
    if (this.thumbnail) {
      this.loadEventImage(this.thumbnail);
    }
  }

  async loadEventImage(event_thumb: string) {
    if (event_thumb !== "" && event_thumb !== "FALTA IMPLEMENTAR") {
      this.eventImage = `${environment.BLOB_URL}/${event_thumb}`;
    }
  }
}
